import { render, staticRenderFns } from "./RealEstateRentContractsInquiry.vue?vue&type=template&id=c2f104a8&"
import script from "./RealEstateRentContractsInquiry.vue?vue&type=script&lang=js&"
export * from "./RealEstateRentContractsInquiry.vue?vue&type=script&lang=js&"
import style0 from "./RealEstateRentContractsInquiry.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports